exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-preview-project-package-filter-pagination {\n  display: flex;\n  justify-content: center;\n  margin: 15px 10px 10px 0px;\n  width: 90%;\n}\n.tag-preview-results-container .document-title {\n  display: flex;\n  gap: 10;\n  font-weight: 500;\n}\n", ""]);

// exports
